import React from 'react';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';

import {selectUserDetails} from 'src/modules/profile/user/services/user-page-slice';

import {Icon, Icons} from '@pb/kit-component-icon';
import {Tooltip} from '@pb/kit-component-popups';


import {userActivityLockedLabel} from './user-activity.module.styl';

type Props = {
    userId: number,
};

export const UserAuthInfoLabel: React.FC<Props> = ({userId}) => {
    const {authInfo} = useSelector(selectUserDetails);

    if (authInfo?.error) {
        return (
            <Tooltip anchor={({anchorRef, getAnchorProps}) => (
                <b ref={anchorRef} {...getAnchorProps()}><Icon type={Icons.ERROR}/> Cannot get current user status</b>
            )}>
                {authInfo.error.message}
            </Tooltip>
        );
    }

    if (authInfo?.data?.email && authInfo?.data?.locked) {
        return (
            <Link to={`/profile/user/${userId}/login`} className={userActivityLockedLabel}>
                <Tooltip anchor={({anchorRef, getAnchorProps}) => (
                    <b ref={anchorRef} {...getAnchorProps()}><Icon type={Icons.ERROR}/> User Locked</b>
                )}>
                    The user will be automatically unlocked in 30 minutes
                </Tooltip>
            </Link>
        );
    }

    return null;
};
